import {MutationTree} from 'vuex';
import {AdminState} from '@/store/modules/Admin/state';
import {AdminMessageAPI, AdminMessageListAPI, AdminUserMessageAPI} from '#/Conversations';
import {AdminMessageType} from '@/store/modules/Conversations/state';
import {StatsAPI} from '#/Stats';
import dayjs from 'dayjs';

export const mutations: MutationTree<AdminState> = {
    LOAD_NEW_ADMIN_MESSAGES: (state: AdminState, {next, previous, results}: AdminMessageListAPI): void => {
        state.next = next;
        state.previous = previous;
        state.popMessages.splice(0, state.popMessages.length);
        state.newPrivateMessages.splice(0, state.newPrivateMessages.length);

        results.forEach(({sentAt, type, ...rest}) => {
                state[type === AdminMessageType.MESSAGE ? 'newPrivateMessages' : 'popMessages']
                    .push({
                        sentAt: new Date(sentAt),
                        type,
                        ...rest,
                    });
            },
        );
    },

    LOAD_ADMIN_MESSAGES: (state: AdminState, messages: AdminMessageAPI[] | AdminUserMessageAPI[]): void => {
        state.privateMessages.splice(0, state.privateMessages.length);

        messages.sort((a, b) => {
            if (a.id < b.id) return -1;
            if (a.id > b.id) return 1;
            return 0;
        })
                .forEach((message) => {
                        if ('readAt' in message) {
                            // Message de type user-message
                            state.privateMessages.push({
                                ...message,
                                sentAt: new Date(message.sentAt),
                                readAt: message.readAt ? new Date(message.readAt) : null,
                            });
                        } else {
                            // Message de type admin-message
                            state.privateMessages.push({
                                ...message,
                                sentAt: new Date(message.sentAt),
                                readAt: null,
                            });
                        }
                    },
                );
    },

    LOAD_STATS: (state: AdminState, stats: StatsAPI): void => {
        state.stats.adminMessageNumber = stats.adminmessageNumber.map(({num, month}) => ({
            month: dayjs(month),
            num,
        }));
        state.stats.messageNumber = stats.messageNumber.map(({num, month}) => ({
            month: dayjs(month),
            num,
        }));
        state.stats.publishedAdvertsNumber = stats.publishedAdvertsNumber.map(({num, month}) => ({
            month: dayjs(month),
            num,
        }));
        state.stats.userMessageNumber = stats.usermessageNumber.map(({num, month}) => ({
            month: dayjs(month),
            num,
        }));
        state.stats.userNumber = stats.userNumber.map(({num, month}) => ({
            month: dayjs(month),
            num,
        }));
    },
};
